
import React from 'react';

interface MapErrorStateProps {
  error: string;
  onRetry?: () => void;
}

const MapErrorState: React.FC<MapErrorStateProps> = ({ error, onRetry }) => {
  return (
    <div className="relative w-full h-full min-h-[400px] rounded-lg overflow-hidden bg-red-50 flex items-center justify-center">
      <div className="text-center p-4">
        <div className="text-red-500 text-lg mb-2">⚠️</div>
        <div className="text-sm font-medium text-red-700 mb-1">Map Error</div>
        <div className="text-xs text-red-600">{error}</div>
        {onRetry && (
          <button 
            onClick={onRetry}
            className="mt-2 px-3 py-1 bg-red-500 text-white text-xs rounded hover:bg-red-600"
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default MapErrorState;
